import { DropDown, Button, DatePeriodTypesEnum } from 'dash-ui';
import { startCase, camelCase } from 'lodash';
import { useTranslation } from 'react-i18next';
import TimeRangeModal from './TimeRangeModal';

const TimeRangeDropdown = ({ filterState }: Record<string, any>) => {
  const { t } = useTranslation('common');

  return (
    <DropDown
      w="100%"
      trigger="none"
      Anchor={() => (
        <Button
          iconRight="arrowDown"
          variation="outline"
          whiteSpace="nowrap"
          iconRightProps={{ size: 20 }}
          mr={3}
          w="100%"
        >
          {startCase(
            t(
              `common:labels.dateRangePeriods.${camelCase(
                filterState.periodType || DatePeriodTypesEnum.CURRENT_WEEK
              )}`
            ) || ''
          )}
        </Button>
      )}
    >
      {({ closeDropdown }) => <TimeRangeModal onClose={closeDropdown} />}
    </DropDown>
  );
};

export default TimeRangeDropdown;
